import http from '../../../../../common/utils/http'
import { API_BASE_URL } from '../../../../../common/utils/commonUrl'
import moment from 'moment'

export default {
  data () {
    return {
      type: 1,
      ruleForm: {
        carNumber: '',
        serviceTeam: null,
        serviceAdvisor: null,
        maintenanceCategory: null,
        major: null,
        toShopTime: moment().format(),
        remark: '',
        maintenanceItemIdList: []
      },
      rules: {
        carNumber: [
          { required: true, message: '请输入车牌号', trigger: 'blur' }
        ],
        serviceTeam: [
          { required: true, message: '请选择服务班组', trigger: 'change' }
        ],
        serviceAdvisor: [
          { required: true, message: '请选择服务顾问', trigger: 'change' }
        ],
        major: [
          { required: true, message: '请选择主修人', trigger: 'change' }
        ],
        maintenanceCategory: [
          { required: true, message: '请选择维修类别', trigger: 'change' }
        ],
        toShopTime: [
          { required: true, message: '请选择进场日期', trigger: 'change' }
        ],
        maintenanceItemIdList: [
          { required: true, message: '请选择预检项目', trigger: 'change' }
        ]

      },
      memberServiceTeamList: [],
      memberServiceAdvisorList: [],
      membeMajorList: [],
      memberServiceAdvisorList2: [],
      membeMajorList2: [],
      csmRemanufacturingAppointmentKanbanItemNameList: [],
      memberMaintenanceItemList: [],
      memberBigMaintenanceItemList: [],
      isSubmitForm: false
    }
  },
  watch: {
    async 'ruleForm.serviceTeam' () {
      let arr = this.memberServiceTeamList.filter(item => item.dictCode == this.ruleForm.serviceTeam)
      this.memberServiceAdvisorList2 = this.memberServiceAdvisorList.filter(item => item.parentId == arr[0].id)
      let membeMajorList = await http.get(API_BASE_URL + '/api/wxoa/member/memberBasis/getMajor?parentId=' + arr[0].id)
      this.membeMajorList = membeMajorList.data.data
    }
  },
  methods: {

    linkHref (e) {
      document.getElementById(e).scrollIntoView({
        behavior: 'smooth', // 定义动画过渡效果， "auto"或 "smooth" 之一。默认为 "auto"
        block: 'center', // 定义垂直方向的对齐， "start", "center", "end", 或 "nearest"之一。默认为 "start"
        inline: 'nearest' // 定义水平方向的对齐， "start", "center", "end", 或 "nearest"之一。默认为 "nearest"
      })
    },
    async getDictCode () {
      // 服务班组
      let memberServiceTeamList = await http.get(API_BASE_URL + '/api/dict/typeCode/memberServiceTeam')
      this.memberServiceTeamList = memberServiceTeamList.data.data
      // 服务顾问
      let memberServiceAdvisorList = await http.get(API_BASE_URL + '/api/dict/typeCode/memberServiceAdvisor')
      this.memberServiceAdvisorList = memberServiceAdvisorList.data.data
      // 主修人
      // let membeMajorList = await http.get(API_BASE_URL + '/api/wxoa/member/memberBasis/getMajor')
      // this.membeMajorList = membeMajorList.data.data
      // 维修类别
      let csmRemanufacturingAppointmentKanbanItemNameList = await http.get(API_BASE_URL + '/api/dict/typeCode/memberMaintenanceCategory')
      this.csmRemanufacturingAppointmentKanbanItemNameList = csmRemanufacturingAppointmentKanbanItemNameList.data.data
      // 预检项目
      let memberMaintenanceItemList = await http.get(API_BASE_URL + '/api/dict/typeCode/memberMaintenanceItem')
      this.memberMaintenanceItemList = memberMaintenanceItemList.data.data
      // 预检项目类别
      let memberBigMaintenanceItemList = await http.get(API_BASE_URL + '/api/dict/typeCode/memberBigMaintenanceItem')
      this.memberBigMaintenanceItemList = memberBigMaintenanceItemList.data.data.map(item => {
        return {
          lessName: item.label.slice(0, 1),
          ...item
        }
      })
    },
    async getOverhaulDetail () {
      let res = await http.get(API_BASE_URL + '/api/wxoa/member/memberBasis/getOverhaulAfterMaintenanceDetail?id=' + this.$route.query.id)
      this.ruleForm = res.data.data
    },
    radioChange () {
      this.ruleForm.serviceAdvisor = null
      this.ruleForm.major = null
    },
    submitForm (formName) {
      if (this.isSubmitForm) return
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.isSubmitForm = true
          let api = ''
          if (this.type == 1) {
            api = '/api/wxoa/member/memberBasis/createOverhaul' // 创建
          } else {
            api = '/api/wxoa/member/memberBasis/patchOverhaulAfterMaintenance' // 修改
          }
          http.post(API_BASE_URL + api, this.ruleForm).then(res => {
            if (res.data.code && res.data.code === 'SUCC-0000') {
              this.$message({
                message: '保存成功！',
                type: 'success'
              })
              this.$router.go(-1)
              this.isSubmitForm = false
            } else {
              this.$message.error('保存失败！')
              this.isSubmitForm = true
            }
          }).catch(err => {
            console.log(err)
            this.$message.error('保存失败！')
            this.isSubmitForm = true
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }

  },
  async mounted () {
    await this.getDictCode()
    if (this.$route.query.id) {
      this.type = 2
      await this.getOverhaulDetail()
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/member/views/completion-modification/completion-modification.js